import { useContext, useEffect, useState } from 'react';
import { DataContext } from '../data/DataContext';
import { IconCheck } from '../img'
import { DropDown, CheckBoxOnly, TableRow } from '../components';
const Step4 = () => {

    const { AutoCR, setAutoCR, changeHandler } = useContext(DataContext);


    const change = (idCoverage: number, prop: string, value: string) => {
        const newLst = AutoCR.lstCoverageExt.map((item: ICoveragesExt) => {
            if (item.idCob !== idCoverage) return item;
            return { ...item, [prop]: value }
        })
        setAutoCR({ ...AutoCR, lstCoverageExt: newLst })
    }

    return (
        <>
            <div className='lbl-input-auto-cr'><span>Coberturas incluidas</span></div>
            {AutoCR.lstCoverageExt.filter(x => x.obligatoria).map((x) => {
                return (<TableRow row={x} change={change} prefix={AutoCR.currency} />);
            })}
            <div className='mt-20 lbl-input-auto-cr'><span>Coberturas opcionales</span></div>
            {AutoCR.lstCoverageExt.filter(x => x.obligatoria === false).map((x) => {
                return (<TableRow row={x} change={change} prefix={AutoCR.currency}  />);
            })}
        </>
    )
}

export { Step4 }